/* otf-od-track.js — 23 Oct 2026. Counts how far shoppers get through the
   Order details sheet (fluid-motion.js) so we can see where the bag-to-checkout
   drop happens. It publishes Shopify custom events only; the custom pixel
   "OTF order-details tracker" (Settings > Customer events) forwards them to the
   Meta pixel as OrderDetailsOpened / Continue / Blocked / Passed.
   It sends no names, phones, addresses or card text: only the step, which
   checks failed (the sheet's own data-e keys: date, time, gift, otfaddr) and
   the page language. It listens in the capture phase and never stops, delays
   or changes a click. Safe to delete: nothing else reads it. */
(function () {
  function pub(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data);
    } catch (e) {}
  }
  function lang() { return document.documentElement.lang || ''; }
  function sheet() { var s = document.querySelectorAll('.fluid-ord'); return s.length ? s[s.length - 1] : null; }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-openorder]')) { pub('otf_od_opened', { lang: lang() }); return; }
    var go = t.closest('.fluid-ord .fluid-ogo');
    if (!go || go.disabled) return;
    pub('otf_od_continue', { lang: lang() });
    // The sheet validates synchronously in its own click handler, so by the
    // next task its error lines (.fluid-oerr.on) are already set.
    setTimeout(function () {
      var s = sheet(); if (!s) return;
      var on = s.querySelectorAll('.fluid-oerr.on'), r = [];
      for (var i = 0; i < on.length; i++) {
        var k = on[i].getAttribute('data-e');
        if (k && r.indexOf(k) < 0) r.push(k);
      }
      if (r.length) pub('otf_od_blocked', { reasons: r.sort().join(','), lang: lang() });
      else pub('otf_od_passed', { lang: lang() });
    }, 0);
  }, true);
})();
